<template>
  <el-dialog
      :visible.sync="visible"
      title="物料清单设置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1100px"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="w-full flex justify-end mb-4">
        <div class="template-box">
          <el-select v-model="bomTemplateId" placeholder="请选择单耗模板" size="mini" style="margin-right: 10px;" @change="selBomTemplate" :filterable="true">
            <el-option
                v-for="item in bomTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
<!--          <el-tag-->
<!--              v-for="item in bomTemplateList"-->
<!--              :key="item.id"-->
<!--              class="item"-->
<!--              @click="selBomTemplate(item)"-->
<!--          >-->
<!--            {{ item.name }}-->
<!--          </el-tag>-->
        </div>

        <el-button
            size="mini"
            icon="el-icon-plus"
            @click="addRow()"
            type="primary"
        >增加原料
        </el-button
        >
      </div>
      <el-table :data="dataForm.detailList" border style="width: 100%" max-height="400">
        <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="原料名称" align="center">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.name'"
                :rules="dataRule.name"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.name" placeholder="名称" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.color'"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.color" placeholder="颜色" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="规格"
            prop="size"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.size'"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.size" placeholder="规格" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="幅宽" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.attr1'"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.attr1" placeholder="幅宽" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="克重" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.attr2'"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.attr2" placeholder="克重" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="单耗"
            header-align="center"
            align="center"
            width="120"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="dataRule.count"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            width="100"
            label="操作"
        >
          <template slot-scope="scope">
            <el-button
                type="text"
                icon="el-icon-remove"
                size="mini"
                @click="delRow(scope.$index, scope.row, 'detailList')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel()" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" size="mini">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isNumber, moneyValidator } from '@/utils/validate'
import BomService from '@/service/BomService'

export default {
  mixins: [],
  data () {
    return {
      visible: false,
      parentId: '',
      bomTemplateId:'',
      dataForm: {
        detailList: [],
      },
      bomTemplateList: [],
    }
  },
  computed: {
    dataRule () {
      return {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        code: [{ required: true, message: '请填写品番号', trigger: 'change' }],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          }
        ],
      }
    },
  },
  methods: {
    selBomTemplate (templateId) {
      const item=this.bomTemplateList.find(item=>item.id===templateId)
      console.log('selBomTemplate', item)
      if (!item.detailList) {
        return
      }
      let detailList = JSON.parse(item.detailList)
      if (!detailList || detailList.length === 0) {
        return
      }
      detailList.forEach((b) => {
        if (!b.count) {
          b.count = ''
        }
      })
      this.dataForm.detailList = detailList
    },
    getBomTemplateList () {
      this.$http.get(`/trade/bom/template/list`).then(({ data: res }) => {
        this.bomTemplateList = res.data
      })
    },
    async getBomList () {
      if (!this.parentId) {
        return
      }
      const { data: res } = await this.$http.get(`/trade/bom/list`, {
        params: { agreementDetailId: this.parentId },
      })
      if (res.data) {
        this.dataForm.detailList = res.data
      }
    },
    cancel () {
      this.visible = false
    },
    delRow (index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1)
      }
    },
    getNewRow () {
      return {
        name: '',
        code: '',
        color: '',
        size: '',
        attr1: '',
        attr2: '',
        count: '',
        unit: ''
      }
    },
    addRow (dataKey) {
      if (!dataKey) {
        dataKey = 'detailList'
      }
      this.dataForm[dataKey].push(this.getNewRow())
    },
    async reset () {
      this.dataForm.detailList = []
      await this.getBomList()
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].clearValidate()
      }
    },
    init () {
      this.bomTemplateId=''
      this.getBomTemplateList()
      this.reset()
      this.visible = true
    },
    checkUnique () {
      let r = true
      if (!this.dataForm.detailList || this.dataForm.detailList.length === 0) {
        return r
      }

      for (let i = 0; i < this.dataForm.detailList.length; i++) {
        let item = this.dataForm.detailList[i]
        for (let j = 0; j < this.dataForm.detailList.length; j++) {
          let item2 = this.dataForm.detailList[j]
          if (i === j) {
            continue
          }
          let pk =
              item.code === item2.code &&
              item.name === item2.name &&
              item.color === item2.color &&
              item.size === item2.size &&
              item.attr1 === item2.attr1 &&
              item.attr2 === item2.attr2 && item.unit === item2.unit
          if (pk) {
            console.log(item, item2)
            return !pk
          }
        }
      }
      return r
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate(
          (valid) => {
            if (!valid) {
              return false
            }
            if (!this.checkUnique()) {
              return this.$message.error('存在重复原辅料,请检查')
            }
            let postForm = this.$clone(this.dataForm.detailList)
            postForm.forEach((item) => {
              item.agreementDetailId = this.parentId
              item.material = {
                name: item.name,
                color: item.color,
                size: item.size,
                attr1: item.attr1,
                attr2: item.attr2,
                type:this.$const.ProductType.MATERIAL
              }
            })
             this.$api2.post(`/erp/bom/save`, postForm).then(res=>{
              this.$emit('change')
              this.$message.success("保存成功");
            })
            this.visible = false
          },
          1000,
          { leading: true, trailing: false }
      )
    }),
  },
}
</script>

<style lang="scss" scoped>
.template-box {
  display: flex;
  padding: 0 20px;
  flex-wrap: wrap;
  padding-right: 0;

  .item {
    margin-right: 20px;
    cursor: pointer;
  }
}
</style>
